import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { giftEdit } from '@/api/gmtool/packageCode';
import { gmTool } from "@/mixins/index";
export default {
  mixins: [gmTool],
  props: {
    prod: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      dialogShow: false,
      paramsData: {
        reward_num: '',
        dead_times: ''
      },
      rules: {
        dead_times: [{
          required: true,
          message: this.$t('pleaseSelectExpireTime'),
          trigger: "blur"
        }],
        reward_num: [{
          required: true,
          message: this.$t('pleaseInputCount'),
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {},
  methods: {
    open: function open(data) {
      this.paramsData = _objectSpread({}, data);
      this.dialogShow = true;
    },
    hiad: function hiad() {
      this.dialogShow = false;
    },
    clearData: function clearData() {
      this.paramsData = {
        reward_num: '',
        dead_times: ''
      };
      this.$refs.ruleForm.clearValidate();
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this = this;

      this.$refs.ruleForm.clearValidate();
      var paramsData = JSON.parse(JSON.stringify(this.paramsData));
      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var _this$paramsData = _this.paramsData,
              gen_id = _this$paramsData.gen_id,
              dead_times = _this$paramsData.dead_times,
              reward_num = _this$paramsData.reward_num;
          var params = {
            id: gen_id,
            reward_num: reward_num,
            dead_times: dead_times,
            is_prod: _this.prod.is_prod
          };
          giftEdit(params).then(function (res) {
            if (res.status == 200) {
              _this.$message({
                message: _this.$t('modifySuccess'),
                type: 'success'
              });

              _this.dialogShow = false;

              _this.$emit('update');
            }
          });
        }
      });
    }
  }
};